import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import leng from '../constants/leng';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'es',
    debug: false,
    resources: {
      en: {
        translation: leng.EN,
      },
      es: {
        translation: leng.ES,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
